import { render } from "./ExpansionPanels.vue?vue&type=template&id=4a99ff7c&scoped=true"
import script from "./ExpansionPanels.vue?vue&type=script&lang=js"
export * from "./ExpansionPanels.vue?vue&type=script&lang=js"

import "./ExpansionPanels.vue?vue&type=style&index=0&id=4a99ff7c&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a99ff7c"]])

export default __exports__